<template>
    <div>
      <Head :title="'Backtoworkconnect.ie Events'" />
      <v-container class="lighten-5" style="padding-bottom:65px">
        <v-row v-if="events">
            <EventCard v-for="e in events" :event="e" :baseurl="baseurl" :key="e.id"></EventCard>
        </v-row>
      </v-container>
    </div>
</template>
<script>
  import { Head } from '@inertiajs/inertia-vue'
  import Layout from '@/Shared/VuetifyLayout'
  import axios from 'axios'
  import EventCard from '@/Shared/EventCard'

  export default {
    props: {
      auth: Object,
      state: String,
      baseurl: String,
      prevurl: String,
      events: Object,
      free_spaces: Number,
      msg: String,
      alert_type: String,
      events: Array
    },
    components: {
      Head,
      EventCard
    },
    layout: Layout,
    data() {
        return {
           
        }
    },
    watch: {
    },
    created() {
    },
    methods: {
        
        prettyDate(x) {
            var options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };

            return new Date(x).toLocaleDateString(undefined,options)
        },
        prettyTime(x) {
            return x.slice(0, -3).replace(/^[0]/g,"");
        },
        
    },
  }
  </script>
  
  <style>
    .fixedFooter {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    color: white;
    text-align: center;
    }
    </style>